<template>
  <v-container fluid tag="section">
    <base-material-card color="success" inline title="Add User" class="px-12 py-1 mx-auto">
      <formulate-form @submit="save" :errors="inputErrors" :form-errors="formErrors">
        <v-row class="space-evenly">
          <v-col cols="12" md="3">
            <formulate-input
              v-model="userData.email"
              type="email"
              name="email"
              label="Email"
              placeholder="Email"
              validation="required|email"
              error-behavior="blur"
            />

            <formulate-input
              v-model="userData.password"
              label="Password"
              type="password"
              name="password"
              placeholder="Password"
              error-behavior="blur"
              validation="required"
            />

            <!-- validation="^required|min:4,length|matches:/[0-9]/"
              :validation-messages="{
                matches: 'Passwords require at least one number.'
            }"-->

            <!-- <formulate-input
                type="select"
                name="state"
                label="State"
                :options="{VA: 'Virginia', CA: 'California', NY: 'New York'}"
            />-->

            <formulate-input
              id="services"
              v-model="selectedServices"
              :options="services"
              type="checkbox"
              label="Select your services"
              for="services"
            />

            <formulate-input
              v-model="userData.allowManual"
              :options="{ true: 'Yes', false: 'No' }"
              type="radio"
              for="allowManual"
              label="Do you want to allow Manual Booking ?"
            />
          </v-col>
          <v-col cols="12" md="3">

            <formulate-input
              v-model="selectedProvider"
              type="radio"
              label="Select your provider"
              name="selectedProvider"
              :options="{ autocab: 'Autocab', infocab: 'Infocab' }"
              for="selectedProvider"
              :element-class="(context, classes) => ['sms-gateway-element-class'].concat(classes)"
            />

            <div >
              <formulate-form v-if="selectedProvider === 'autocab'" @submit="fetchCompanies">
                <formulate-input
                  v-model="userData.api_username"
                  type="text"
                  name="api_username"
                  label="API Username"
                  placeholder="Enter API username"
                  validation="required"
                  error-behavior="blur"
                />
                <formulate-input
                  v-model="userData.api_password"
                  type="text"
                  name="api_password"
                  label="API Password"
                  placeholder="Enter API password"
                  validation="required"
                  error-behavior="blur"
                />
                <formulate-input
                  v-model="userData.api_host"
                  type="url"
                  name="api_host"
                  label="API Host"
                  placeholder="Enter API Host Url"
                  validation="required"
                  error-behavior="blur"
                />

                <formulate-input
                  type="submit"
                  :disabled="disableFetchButton"
                  name="Fetch Companies"
                />
              </formulate-form>
              <formulate-form v-else-if="selectedProvider === 'infocab'" @submit="fetchInfoCompanies">
                <formulate-input
                  v-model="userData.infocab_host"
                  type="url"
                  name="infocab_host"
                  label="Infocab host"
                  placeholder="Enter infocab host"
                  validation="required"
                  error-behavior="blur"
                />
                <formulate-input
                  v-model="userData.infocab_token"
                  type="text"
                  name="infocab_token"
                  label="Infocab Token"
                  placeholder="Enter Infocab Token"
                  validation="required"
                  error-behavior="blur"
                />
                <formulate-input
                  type="submit"
                  :disabled="disableInfoFetchButton"
                  name="Fetch Companies"
                />
              </formulate-form>

              <formulate-input
                v-show="companies.length"
                v-model="selectedCompanies"
                class="mt-7"
                :options="companies"
                id="check"
                type="checkbox"
                label="Select Companies"
                for="companies"
              />
              <div v-for="sc in selectedCompanies" :key="sc">
                <formulate-input type="button" @click="setJudoAccount(sc)">
                  Add Judo for {{ sc }}</formulate-input
                >
              </div>
            </div>

          </v-col>

          <!-- {{ selectedCompanies }} -->
          <v-col cols="12" md="3">
            <formulate-input
              v-model="userData.sms_service"
              type="radio"
              label="Select your SMS method"
              name="payment"
              :options="{ twillio: 'Twillio', whatsApp: 'WhatsApp/URL' }"
              for="sms"
              :element-class="(context, classes) => ['sms-gateway-element-class'].concat(classes)"
            />
            <formulate-input v-show="userData.sms_service == 'twillio'" type="group">
              <formulate-input
                v-model="userData.twillio.sid"
                type="text"
                name="twillio_sid"
                label="Twillio SID"
                placeholder="Twillio SID"
                validation="twillio_validation"
                :validation-rules="{
                  twillio_validation: ({ value }) =>
                    !(userData.twillio.sid == '' && userData.sms_service == 'twillio'),
                }"
                :validation-messages="{
                  twillio_validation: 'SID is required.',
                }"
                error-behavior="blur"
              />
              <formulate-input
                v-model="userData.twillio.auth"
                type="text"
                name="twillio_auth"
                label="Twillio Auth Token"
                placeholder="Twillio Auth Token"
                validation="twillio_validation"
                :validation-rules="{
                  twillio_validation: ({ value }) =>
                    !(userData.twillio.auth == '' && userData.sms_service == 'twillio'),
                }"
                :validation-messages="{
                  twillio_validation: 'Auth token is required.',
                }"
                error-behavior="blur"
              />
              <formulate-input
                v-model="userData.twillio.number"
                type="text"
                name="twillio_number"
                label="Twillio Number"
                placeholder="Twillio Number"
                validation="twillio_validation"
                :validation-rules="{
                  twillio_validation: ({ value }) =>
                    !(userData.twillio.number == '' && userData.sms_service == 'twillio'),
                }"
                :validation-messages="{
                  twillio_validation: 'Number is required.',
                }"
                error-behavior="blur"
              />
            </formulate-input>
            <formulate-input v-show="userData.sms_service == 'whatsApp'" type="group">
              <formulate-input
                v-model="userData.whatsApp.link"
                name="link"
                label="Url link"
                placeholder="Enter Url link"
                validation="twillio_validation"
                :validation-rules="{
                  twillio_validation: ({ value }) =>
                    !(userData.whatsApp.link == '' && userData.sms_service == 'whatsApp'),
                }"
                :validation-messages="{
                  twillio_validation: 'URL link is required.',
                }"
                error-behavior="blur"
              />
              <formulate-input
                v-model="userData.whatsApp.password"
                type="text"
                name="password"
                label="Url Link password"
                placeholder="Enter Url password"
                validation="twillio_validation"
                :validation-rules="{
                  twillio_validation: ({ value }) =>
                    !(userData.whatsApp.password == '' && userData.sms_service == 'whatsApp'),
                }"
                :validation-messages="{
                  twillio_validation: 'URL link password is required.',
                }"
                error-behavior="blur"
              />
            </formulate-input>
            <formulate-input type="submit" name="Save User" />
          </v-col>
        </v-row>
        <!-- <v-row justify="center">
        </v-row>-->
      </formulate-form>
    </base-material-card>
    <v-dialog v-model="dialog" max-width="800">
      <v-card class="text-center">
        <v-card-title>
          Add Judo Credentials for {{ current_judo.company }}

          <v-spacer />

          <v-icon aria-label="Close" @click="dialog = false"> mdi-close </v-icon>
        </v-card-title>
        <v-card-text class="px-12 py-1 mx-auto">
          <formulate-form @submit="saveJudoCredentials">
            <v-row>
              <v-col cols="12" md="6">
                <formulate-input
                  v-model="current_judo.judo_id"
                  type="text"
                  name="judo_id"
                  label="Judo ID"
                  placeholder="Enter Judo ID"
                />
                <formulate-input
                  v-model="current_judo.judo_auth_sandbox"
                  type="text"
                  name="judo_auth_sandbox"
                  label="Judo Auth Sandbox"
                  placeholder="Enter Judo Auth Sandbox"
                />
              </v-col>
              <v-col cols="12" md="6">
                <formulate-input
                  v-model="current_judo.judo_sandbox_url"
                  type="url"
                  name="judo_sandbox_url"
                  label="Judo Sandbox Url"
                  placeholder="Enter Judo Sandbox Url"
                />
                <formulate-input
                  v-model="current_judo.judo_api_version"
                  type="text"
                  name="judo_api_version"
                  label="Judo API version"
                  placeholder="Enter Judo API version"
                />

                <div class="flex">
                  <formulate-input
                    type="submit"
                    name="Save Credentials"
                    :disabled="
                      current_judo.judo_id == '' ||
                      current_judo.judo_sandbox_url == '' ||
                      current_judo.judo_auth_sandbox == '' ||
                      current_judo.judo_api_version == ''
                    "
                  />
                  <formulate-input
                    v-if="editJudoCredentials"
                    @click="removeJudoCredentials(current_judo.company)"
                    type="button"
                    name="Remove Account"
                    :element-class="(context, classes) => ['ml-10'].concat(classes)"
                  />
                </div>
              </v-col>
            </v-row>
          </formulate-form>
        </v-card-text>
      </v-card>
    </v-dialog>
    <base-material-snackbar
      v-model="snackbar"
      type="error"
      class=""
      v-bind="{
        bottom: true,
        right: true,
      }"
      >{{ snackbarText }}</base-material-snackbar
    >
  </v-container>
</template>

<script>
import { _getCompanies, _getInfoCompanies, _saveAdmin, _getServices } from '@/services/User'
import { setToken } from '@/services/Http'
export default {
  name: 'AddUser',
  data: () => ({
    selectedProvider: 'autocab',
    formErrors: [],
    inputErrors: {},
    userData: {
      email: null,
      password: null,
      api_username: 'DGcars',
      api_password: 'DGcars2020!',
      api_host: 'https://ghost-main-static-b36cb86a19e14a2386de12935fac6526.ghostapi.app:29003',
      sms_service: 'twillio',
      twillio: {
        sid: '',
        auth: '',
        number: '',
      },
      infocab_host: 'https://stage-webbookerapi.infocabs.com',
      infocab_token: 'n0XynNayLlVW8vDsoG59MydnLUj5iVrkjrLgbZqU7HA=',
      whatsApp: {
        link: '',
        password: '',
      },
      allowManual: true,
    },
    companies: [],
    selectedCompanies: [],
    services: [],
    selectedServices: [],
    disableFetchButton: false,
    disableInfoFetchButton: false,
    apiError: '',
    snackbar: false,
    snackbarText: ' Email already exists',
    show: false,
    dialog: false,

    current_judo: {
      company: '',
      judo_id: '',
      judo_sandbox_url: '',
      judo_api_version: '',
      judo_auth_sandbox: '',
    },
    selectedCompaniesJudo: [],
    editJudoCredentials: false,
  }),
  mounted() {
    setToken()
    this.getServices()
  },
  watch: {
    selectedProvider(newProvider) {
      this.companies = [];
      this.selectedCompanies = [];
      // Emit event or perform logic based on selection
      console.log('Provider switched to:', newProvider)
      this.$emit('provider-changed', newProvider)
    },
    selectedCompanies(newval) {
      this.selectedCompaniesJudo = this.selectedCompaniesJudo.filter((f) =>
        newval.includes(f.company)
      )
    },
  },

  methods: {
    fetchInfoCompanies() {
      this.disableInfoFetchButton = true;
      this.companies = []
      this.selectedCompanies = []
      let formData = {
        info_host: this.userData.infocab_host,
        info_token: this.userData.infocab_token,
      }
      _getInfoCompanies(formData)
        .then(
          (response) => {

            this.disableInfoFetchButton = false
            this.apiError = ''
            let data = response.data.obj.divisions
            this.companies = data.map(function (d) {
              return {
                company_id: d.Id,
                name: d.Name,
                label: d.Name,
                value: d.Name,
                latitude: (d.latitude !== undefined && d.latitude !== null) ? d.latitude : 0,
                longitude: (d.longitude !== undefined && d.longitude !== null) ? d.longitude : 0,
                info_parent_id : d.CompanyId

              }
            })



          },
          (error) => {
            this.disableFetchButton = false
            this.disableInfoFetchButton = false
            this.snackbar = true
            this.snackbarText = error.data.responseMessage
          });
    },
    fetchCompanies() {
      this.disableFetchButton = true
      this.companies = []
      this.selectedCompanies = []
      let formData = {
        api_username: this.userData.api_username,
        api_password: this.userData.api_password,
        api_host: this.userData.api_host,
      }

      _getCompanies(formData)
        .then(
          (response) => {
            this.disableFetchButton = false
            this.apiError = ''
            let data = response.data.obj.companies
            this.companies = data.map(function (d) {
              return {
                company_id: d.id,
                name: d.name,
                label: d.name,
                value: d.name,
                latitude: d.location.latitude,
                longitude: d.location.longitude,
              }
            })

            console.log(this.companies)
          },
          (error) => {
            this.disableFetchButton = false
            this.snackbar = true
            this.snackbarText = error.data.responseMessage
          }
        )
        .catch((err) => {
          this.disableFetchButton = false
          this.snackbar = true
          this.snackbarText = err.message
        })
    },
    save() {
      var self = this
      let companiesObjArray = this.companies
      let sel = this.selectedCompanies
      var filteredCompaniesObj = companiesObjArray.filter((item) => sel.includes(item.name))

      if (filteredCompaniesObj.length) {
        this.userData.companies = filteredCompaniesObj.map((v) => ({
          ...v,
          id: v.company_id,
          judo_account: self.selectedCompaniesJudo.find((item) => item.company === v.name),
        }))
        this.userData.services = this.selectedServices
        this.userData.allowManual =
          this.userData.allowManual == 'true' || this.userData.allowManual == 1 ? 'true' : 'false'

          this.userData.provider = this.selectedProvider;
          if(this.selectedProvider == 'infocab') {
            this.userData.api_username = null;
            this.userData.api_host = null;
            this.userData.api_password = null;
          }
          else {
            this.userData.infocab_host = null;
            this.userData.infocab_token = null;
          }
        _saveAdmin(this.userData)
          .then(
            () => {
              this.$router.push('/users')
            },
            (err) => {
              if (err.data && err.data.status) {
                switch (err.data.status) {
                  case 422:
                    this.inputErrors = err.data.errors // assign field errors
                    this.formErrors = err.data.message
                    return
                  // ... add lots more cases of bad things that can happen here
                }
              }
            }
          )
          .catch((err) => {
            console.log(err.data)
          })
      } else {
        alert('please fetch companies if not and assign')
      }
    },
    getServices() {
      _getServices().then((res) => {
        let objArray1 = res.data.obj
        this.services = objArray1.map((v) => ({
          ...v,
          value: v.id,
          label: v.name,
        }))
      })
    },

    setJudoAccount(company) {
      this.dialog = true

      var value = this.selectedCompaniesJudo.find((data) => data.company === company)
      if (value) {
        this.current_judo = value
        this.editJudoCredentials = true
      } else {
        this.editJudoCredentials = false
        this.current_judo = {
          company: company,
          judo_id: '',
          judo_sandbox_url: '',
          judo_api_version: '',
          judo_auth_sandbox: '',
        }
      }
    },

    saveJudoCredentials() {
      if (!this.editJudoCredentials) this.selectedCompaniesJudo.push(this.current_judo)
      this.dialog = false
    },

    removeJudoCredentials(company) {
      this.selectedCompaniesJudo = this.selectedCompaniesJudo.filter(
        (scj) => scj.company != company
      )

      this.dialog = false
    },
  },
}
</script>

<style>
.sms-gateway-element-class {
  display: flex;
  justify-content: space-around;
}
.flex {
  display: flex;
}
.space-evenly {
  justify-content: space-evenly;
}
</style>
